import { SET_IS_DISCONNECTED } from "../../actions/Calendar/setDisconnectAction";

const initialState = {
    isDisconnected: false,
};

const disconnectReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_IS_DISCONNECTED:
            return {
                ...state,
                isDisconnected: action.payload,
            };
        default:
            return state;
    }
};

export default disconnectReducer;